module.exports = __webpack_public_path__ + "img/downloadGreen.00eb821c.svg";